import { useLanguage } from '@/contexts/LanguageContext';
import { LOCALES } from '@/i18n';
import { useTranslation } from 'react-i18next';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useMemo } from 'react';
import { COUNTRY_FLAGS } from '@/constants/countryFlags';
import { SupportedLocale } from '@/types/supported-locale.type';

const LanguageSwitch = () => {
  const { currentLanguage, changeLanguage } = useLanguage();
  const { t } = useTranslation();

  const LANGUAGES = useMemo(() => {
    return LOCALES.map((lang) => ({
      label: t(`common.languages.${lang}`),
      value: lang,
    }));
  }, [t]);

  return (
    <Select
      onValueChange={(value) => changeLanguage(value as SupportedLocale)}
      defaultValue={currentLanguage.slice(0, 2)}
    >
      <SelectTrigger className="w-full border-0">
        <SelectValue placeholder={t(`common.languages.${currentLanguage}`)} />
      </SelectTrigger>
      <SelectContent>
        {LANGUAGES.map((lang) => (
          <SelectItem key={lang.value} value={lang.value} className="w-full">
            <img
              src={COUNTRY_FLAGS[lang.value]}
              alt={lang.label}
              className="size-5 rounded-full"
            />
            <span>{lang.label}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSwitch;
